import { useAutovioContext } from "./useAutovioContext";
import { drivingSchoolsProvider } from "../providers/drivingSchoolsProvider";
import { usesStripePayments } from "../model/PaymentConfiguration";

export function useStripePaymentsEnabled(drivingSchoolId?: string): boolean {
  const [context] = useAutovioContext();
  const id = drivingSchoolId ?? context.drivingSchoolId;
  return usesStripePayments(id ? drivingSchoolsProvider.getOneFromCache(id) : undefined);
}
